module.exports = __webpack_public_path__ + "static/fonts/iconfont.26c446bb.woff";